import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BillingInfoComponent } from './components/billing-info.component';
import { AppLoginModule } from './../app-login/app-login.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckoutComponent } from './components/checkout.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    AppLoginModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [CheckoutComponent, BillingInfoComponent],
  declarations: [CheckoutComponent, BillingInfoComponent]
})
export class CheckoutModule { }



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/checkout/checkout.module.ts